import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

// We'll use redux-logger just as an example of adding another middleware
import logger from "redux-logger";

// And use redux-batch as an example of adding enhancers
import { reduxBatch } from "@manaflair/redux-batch";

import authenticationReducer from "../features/authentication/authenticationSlice";
import projectsReducer from "../features/projects/projectsSlice";
import mediumsReducer from "../features/mediums/mediumsSlice";
import attendanceReducer from "../features/attendance/attendanceSlice";
import policyReducer from "../features/policy/policySlide";
import uiReducer from "../features/ui/uiSlice";
import categoryReducer from "../features/category/categorySlide";
import notificationsReducer from "../features/notifications/notificationsSlice";

const reducer = {
  authentication: authenticationReducer,
  projects: projectsReducer,
  mediums: mediumsReducer,
  attendance: attendanceReducer,
  policy: policyReducer,
  ui: uiReducer,
  category: categoryReducer,
  notifications: notificationsReducer,
};

let enable = false;
let middleware = [...getDefaultMiddleware()];
if (enable) {
  middleware = [...getDefaultMiddleware(), logger];
}

export default configureStore({
  reducer: reducer,
  middleware,
  enhancers: [reduxBatch],
});
